import { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Toast configuration constants
const TOAST_CONFIG = {
  autoClose: 3000,
  hideProgressBar: false,
  newestOnTop: false,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  draggable: true,
  pauseOnHover: true
};

const Toast = () => {
  const { i18n } = useTranslation('common');

  const toastProps = useMemo(() => ({
    ...TOAST_CONFIG,
    position: i18n.language === 'ar' ? 'top-left' : 'top-right',
    rtl: i18n.language !== 'en'
  }), [i18n.language]);

  return <ToastContainer {...toastProps} />;
};

// Toast types mapping
const TOAST_TYPES = {
  success: toast.success,
  error: toast.error,
  info: toast.info,
  warning: toast.warn,
  default: toast
};

export const showToast = (message, type = 'default') => {
  const toastFunction = TOAST_TYPES[type] || TOAST_TYPES.default;
  toastFunction(message);
};

export default memo(Toast);